import dayjs, { Dayjs } from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import "dayjs/locale/en-gb";
import "dayjs/locale/en-au";
import "dayjs/locale/es-us";
import "dayjs/locale/nl";
// en-us is the default dayjs 'en'

dayjs.extend(localizedFormat);

type dateStyle = "long" | "short";

export function useFormattedDate(date: string | number | Dayjs | Date, dateStyle?: dateStyle) {
   const { locale } = useI18n();

   let dateFormat = "LL";
   if (dateStyle === "short") dateFormat = "L";

   const formattedDate = dayjs(date).locale(locale.value).format(dateFormat);

   return formattedDate;
}
